<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ getMessage_('SWCC000002') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select
				:value="searchParams.plantCd"
				:placeholder="getMessage_('SWCC000002')"
				@change="
					value => {
						return setSearchParam_({ key: 'plantCd', value: value });
					}
				"
			>
				<el-option :key="index" v-for="(plant, index) in plants" :label="plant.commCdName" :value="plant.commCd"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/DicMsgManagement/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods
	}
};
</script>

<style></style>
